import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
function FlowActions({ children, secondary = null, className = '' }) {
    return (_jsxs("div", { className: classNames('flex-finalize-actions', className), children: [_jsx("div", { className: "flex-finalize-actions__primary", children: children }), secondary && (_jsx("div", { className: "flex-finalize-actions__secondary", children: secondary }))] }));
}
export default FlowActions;
